/* EP Runde 27 (18.10.2026): Produktdaten über ?view=ep-catalog (templates/collection.ep-catalog.liquid). EP Runde 14: ausgelagert aus snippets/ep-cart-upsell.liquid. Konfiguration über window.EP_UPSELL_CFG = {pin, count} (im Snippet gesetzt). */
(function(){
  var FREE_SHIP = 6000;
  var GIFT = 13000;
  var WORKER_URL = "https://MHVInternational--e509689c7d2811f1b54a1607ee4eb77e.web.val.run";
  var MAX = 4;                                   // 4 Produkte - alles auf einen Blick
  var PIN_COLLECTION = (window.EP_UPSELL_CFG && window.EP_UPSELL_CFG.pin) || "upsell";
  var PINNED = [];
  /* EP PERF: Warenkorb-Anzahl direkt aus Liquid - bei leerem Warenkorb wird beim Seitenaufruf gar nichts geladen */
  var INITIAL_COUNT = (window.EP_UPSELL_CFG && window.EP_UPSELL_CFG.count) || 0;

  var items, sub, shipEl, goBtn, root;
  var LIVE = {};
  var cart = null;
  var pending = null;
  var busy = false;

  var CACHE = {sig:"", handles:null, reply:""};
  var prefetching = false;
  var loaded = null;

  function esc(s){var d=document.createElement("div");d.textContent=s==null?"":s;return d.innerHTML;}
  function eur(c){return (Number(c)/100).toFixed(2).replace(".",",")+" €";}
  function avVars(p){return p&&p.v?p.v.filter(function(v){return v.av!==false;}):[];}
  function inStock(p){return p&&avVars(p).length>0;}
  function onSale(p){var a=avVars(p)[0];return !!(a&&a.cp&&a.cp>a.p);}
  function saleP(p){var a=avVars(p)[0];if(!a||!a.cp||a.cp<=a.p)return 0;return Math.round((1-a.p/a.cp)*100);}

  function cartSig(){ return cart ? (cart.item_count+"_"+cart.total_price) : ""; }
  function shown(){
    try{
      var last=sessionStorage.getItem("ep_up_sig");
      if(!last)return false;
      var sig=cartSig();
      return sig!=="" && last===sig;
    }catch(e){return false;}
  }
  function markShown(){ try{ var sig=cartSig(); if(sig)sessionStorage.setItem("ep_up_sig",sig); }catch(e){} }

  function stripHtml(h){
    h=(h||"").replace(/<style[\s\S]*?<\/style>/gi,"").replace(/<script[\s\S]*?<\/script>/gi,"");
    var d=document.createElement("div");d.innerHTML=h;
    var t=(d.textContent||"").replace(/\{[\s\S]*?\}/g," ").replace(/\s+/g," ").trim();
    if(/font-family|display:|margin|padding|px;|\.ep-/i.test(t))return "";
    return t;
  }

  /* EP Runde 27 (18.10.2026): Kompakter Katalog aus templates/collection.ep-catalog.liquid statt der Standard-Produktliste
     (1,66 MB mit allen Beschreibungen und Bildern). Felder und Preise (Cent) kommen fertig aus Liquid. */
  function fetchCatalog(path){
    return fetch(path+"?view=ep-catalog",{credentials:"same-origin"})
      .then(function(r){ if(!r.ok)throw 0; return r.json(); })
      .then(function(d){ return (d&&d.products)||[]; });
  }
  function addProduct(p){
    var d=p.d||"";
    if(/font-family|display:|margin|padding|px;|\.ep-/i.test(d))d="";
    LIVE[p.h]={h:p.h,t:p.t,b:(p.b||""),cat:(p.cat||""),img:(p.img||""),d:d.slice(0,80),
               v:(p.v||[]).map(function(v){return {id:v.id,t:v.t,p:Number(v.p)||0,cp:Number(v.cp)||0,av:v.av!==false};}),
               tags:(p.tags||[])};
  }
  function loadProducts(){
    return fetchCatalog("/collections/all").then(function(list){ list.forEach(addProduct); }).catch(function(){});
  }

  function loadPinned(){
    if(!PIN_COLLECTION)return Promise.resolve();
    return fetchCatalog("/collections/"+PIN_COLLECTION)
      .then(function(list){
        PINNED=[];
        list.forEach(function(p){
          if(!LIVE[p.h])addProduct(p);
          PINNED.push(p.h);
        });
      })
      .catch(function(){ PINNED=[]; });
  }

  /* EP PERF: Produktdaten nur ein einziges Mal und nur bei Bedarf laden */
  function ensureLoaded(){
    if(!loaded){ loaded=Promise.all([loadProducts(),loadPinned()]).catch(function(){}); }
    return loaded;
  }

  /* EP PERF: Hintergrundarbeit erst, wenn der Browser Leerlauf hat (nach dem Seitenaufbau) */
  function whenIdle(fn){
    var start=function(){
      if("requestIdleCallback" in window){ window.requestIdleCallback(fn,{timeout:4000}); }
      else { setTimeout(fn,1500); }
    };
    if(document.readyState==="complete"){ start(); }
    else { window.addEventListener("load",start,{once:true}); }
  }

  function getCart(){
    return fetch("/cart.js").then(function(r){return r.json();}).then(function(c){cart=c;return c;});
  }

  function cartHandles(){
    return (cart&&cart.items?cart.items:[]).map(function(i){return i.handle;});
  }

  function localSuggest(){
    var have=cartHandles().map(function(h){return (LIVE[h]?(LIVE[h].t+" "+(LIVE[h].tags||[]).join(" ")):"").toLowerCase();}).join(" ");
    var want=[];
    if(/whey|protein|isolat|casein/.test(have)&&!/shaker/.test(have))want.push("shaker");
    if(/whey|protein/.test(have)&&!/kreatin|creatin/.test(have))want.push("kreatin","creatin");
    if(/kreatin|whey|protein/.test(have)&&!/omega|vitamin/.test(have))want.push("omega","vitamin");
    if(/booster|pump|energy/.test(have)&&!/shaker/.test(have))want.push("shaker");
    want.push("riegel","vitamin","magnesium","omega");

    var out=[],inCart=cartHandles();
    want.forEach(function(kw){
      Object.keys(LIVE).forEach(function(h){
        if(out.length>=MAX)return;
        if(out.indexOf(h)>=0||inCart.indexOf(h)>=0)return;
        var p=LIVE[h];
        if(!inStock(p))return;
        var hay=(p.t+" "+p.cat+" "+(p.tags||[]).join(" ")).toLowerCase();
        if(hay.indexOf(kw)>=0)out.push(h);
      });
    });
    return out.slice(0,MAX);
  }

  function askAI(){
    var names=(cart&&cart.items?cart.items:[]).map(function(i){return i.product_title;});
    if(!names.length)return Promise.resolve(null);

    var pool=[];
    Object.keys(LIVE).forEach(function(h){
      var p=LIVE[h];
      if(!inStock(p))return;
      if(cartHandles().indexOf(h)>=0)return;
      pool.push({h:h,p:p,s:saleP(p)});
    });
    pool.sort(function(a,b){return b.s-a.s;});
    var lines=pool.slice(0,70).map(function(x){
      return "  - handle:"+x.h+" | "+x.p.t+(x.s?" (-"+x.s+"%)":"");
    });

    var q="Im Warenkorb liegen: "+names.join(", ")+". Welche 4 lieferbaren Produkte ergaenzen das sinnvoll? "+
          "Bevorzuge reduzierte Produkte, wenn sie inhaltlich passen. Keine Produkte, die schon im Warenkorb liegen.";

    return fetch(WORKER_URL,{
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({
        messages:[{role:"user",content:q}],
        catalog:lines.join("\n"),
        mode:"upsell",
        customer:{},
        details:""
      })
    }).then(function(r){return r.json();}).then(function(d){
      var out=[];
      (d&&d.products?d.products:[]).forEach(function(h){
        if(LIVE[h]&&inStock(LIVE[h])&&cartHandles().indexOf(h)<0&&out.indexOf(h)<0)out.push(h);
      });
      return {handles:out, reply:(d&&d.reply)||""};
    }).catch(function(){return null;});
  }

  // Immer 4 Produkte:  1) manuell  2) KI  3) reduzierte  4) Rest
  function fillUp(list){
    var out=[],inCart=cartHandles();

    function push(h){
      if(out.length>=MAX)return;
      if(out.indexOf(h)>=0)return;
      if(inCart.indexOf(h)>=0)return;      // schon im Warenkorb -> nie zeigen
      var p=LIVE[h];
      if(!p||!inStock(p))return;           // ausverkauft -> nie zeigen
      out.push(h);
    }

    PINNED.forEach(push);
    (list||[]).forEach(push);

    if(out.length<MAX){
      var sale=[];
      Object.keys(LIVE).forEach(function(h){
        var p=LIVE[h];
        if(inStock(p)&&onSale(p))sale.push({h:h,s:saleP(p)});
      });
      sale.sort(function(a,b){return b.s-a.s;});
      sale.forEach(function(x){ push(x.h); });
    }
    if(out.length<MAX){
      Object.keys(LIVE).forEach(push);
    }
    return out.slice(0,MAX);
  }

  function prefetch(){
    if(prefetching)return;
    prefetching=true;
    getCart().then(function(c){
      if(!c||!c.items||!c.items.length){prefetching=false;return;}
      var sig=cartSig();
      if(CACHE.sig===sig&&CACHE.handles){prefetching=false;return;}
      return ensureLoaded().then(function(){ return askAI(); }).then(function(res){
        CACHE.sig=sig;
        CACHE.handles=fillUp((res&&res.handles&&res.handles.length)?res.handles:localSuggest());
        CACHE.reply=res?res.reply:"";
        prefetching=false;
      });
    }).catch(function(){prefetching=false;});
  }

  function renderShip(){
    var t=cart?cart.total_price:0;
    if(t>=GIFT){shipEl.hidden=true;return;}
    var txt,pct;
    if(t<FREE_SHIP){txt="Noch "+eur(FREE_SHIP-t)+" bis zum kostenlosen Versand";pct=t/FREE_SHIP*100;}
    else{txt="Kostenloser Versand erreicht. Noch "+eur(GIFT-t)+" bis zu deinem Geschenk";pct=t/GIFT*100;}
    if(pct<3)pct=3; if(pct>100)pct=100;
    shipEl.innerHTML='<div>'+esc(txt)+'</div><div class="ep-up-bar"><div class="ep-up-fill" style="width:'+pct+'%"></div></div>';
    shipEl.hidden=false;
  }

  function addToCart(handle,btn){
    var p=LIVE[handle];
    var av=avVars(p);
    if(!av.length)return;
    btn.disabled=true;btn.textContent="...";
    fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},
      body:JSON.stringify({items:[{id:Number(av[0].id),quantity:1}]})})
      .then(function(r){return r.json();})
      .then(function(){ return getCart(); })
      .then(function(){
        btn.textContent="✓ Drin";
        renderShip();
        document.querySelectorAll('[data-header-cart-count],[data-cart-count],.cart-count,.cart-count-bubble').forEach(function(el){el.textContent=cart.item_count;});
      })
      .catch(function(){btn.disabled=false;btn.textContent="+ Hinzufuegen";});
  }

  function render(handles,reply){
    items.innerHTML="";
    handles.forEach(function(h){
      var p=LIVE[h];if(!p)return;
      var av=avVars(p);if(!av.length)return;
      var v=av[0];
      var deal=(v.cp&&v.cp>v.p);
      var pct=deal?Math.round((1-v.p/v.cp)*100):0;
      var row=document.createElement("div");row.className="ep-up-row";
      row.innerHTML=
        '<img src="'+esc(p.img)+'" alt="'+esc(p.t)+'" loading="lazy">'+
        '<div class="ep-up-info">'+
          '<div class="ep-up-n"><a href="/products/'+p.h+'">'+esc(p.t)+'</a></div>'+
          (p.d?'<div class="ep-up-w">'+esc(p.d)+'</div>':'')+
          '<div class="ep-up-p">'+eur(v.p)+
            (deal?'<span class="ep-up-old">'+eur(v.cp)+'</span><span class="ep-up-badge">-'+pct+'%</span>':'')+
          '</div>'+
        '</div>'+
        '<button class="ep-up-add">+ Hinzufuegen</button>';
      var btn=row.querySelector(".ep-up-add");
      btn.onclick=function(){addToCart(h,btn);};
      items.appendChild(row);
    });

    var deals=handles.filter(function(h){return onSale(LIVE[h]);}).length;
    var head=document.querySelector(".ep-up-t");
    if(head){
      head.textContent = deals>0 ? "Jetzt schnell zum Sonderpreis mitnehmen" : "Das passt noch perfekt dazu";
    }
    if(deals>0){
      sub.textContent = (deals===1)
        ? "Ein Produkt ist gerade reduziert - nur solange der Vorrat reicht."
        : deals+" dieser Produkte sind gerade reduziert - nur solange der Vorrat reicht.";
    } else if(reply){
      sub.textContent=reply.slice(0,180);
    } else {
      sub.textContent="Diese Produkte ergaenzen deinen Warenkorb sinnvoll.";
    }
  }

  function openPopup(){ root.hidden=false; document.body.style.overflow="hidden"; }
  function closePopup(){ root.hidden=true; document.body.style.overflow=""; markShown(); }

  function proceed(){
    closePopup();
    var el=pending; pending=null;

    var alive = el && document.contains(el);
    if(alive){
      if(el.tagName==="A"&&el.href){ location.href=el.href; return; }
      var f=el.form||(el.closest?el.closest("form"):null);
      if(f&&document.contains(f)){
        try{
          if(f.requestSubmit){ f.requestSubmit(el); return; }
          f.submit(); return;
        }catch(err){}
      }
    }
    location.href="/checkout";
  }

  function isCheckoutEl(el){
    if(!el)return false;
    if(el.closest&&el.closest("#ep-up"))return false;
    if(el.name==="checkout")return true;
    if(el.getAttribute&&el.getAttribute("name")==="checkout")return true;
    if(el.hasAttribute&&el.hasAttribute("data-ep-checkout"))return true;

    var href=el.getAttribute?el.getAttribute("href"):"";
    if(href&&/\/checkout/.test(href))return true;

    var cls=(el.className&&el.className.baseVal!==undefined)?el.className.baseVal:(el.className||"");
    if(typeof cls==="string"&&/cart__checkout|checkout-button|cart-checkout/.test(cls))return true;

    var txt=(el.textContent||"").trim().toLowerCase();
    if(txt&&txt.length<40&&/(zur kasse|checkout|kasse|jetzt bezahlen|bezahlen)/.test(txt)){
      if(!/paypal|shop pay|shoppay|google|apple/.test(txt))return true;
    }
    return false;
  }

  function grab(){
    root=document.getElementById("ep-up");
    if(!root)return false;
    items=document.getElementById("ep-up-items");
    sub=document.getElementById("ep-up-sub");
    shipEl=document.getElementById("ep-up-ship");
    goBtn=document.getElementById("ep-up-go");
    return true;
  }

  function runPopup(){
    getCart().then(function(c){
      if(!c||!c.items||!c.items.length){busy=false;proceed();return;}
      if(shown()){busy=false;proceed();return;}

      var sig=cartSig();

      if(CACHE.sig===sig&&CACHE.handles&&CACHE.handles.length){
        render(CACHE.handles,CACHE.reply);
        renderShip();
        openPopup();
        busy=false;
        return;
      }

      /* EP PERF: Produktdaten sicherstellen (normalerweise schon im Leerlauf geladen) */
      return ensureLoaded().then(function(){
        var quick=fillUp(localSuggest());
        if(quick.length){
          render(quick,"");
          renderShip();
          openPopup();
          busy=false;
        }

        return askAI().then(function(res){
          var base=(res&&res.handles&&res.handles.length)?res.handles:localSuggest();
          var handles=fillUp(base);
          CACHE.sig=sig; CACHE.handles=handles; CACHE.reply=res?res.reply:"";
          if(!handles.length){ if(!quick.length){busy=false;proceed();} return; }
          if(root&&!root.hidden){ render(handles,res?res.reply:""); renderShip(); }
          else if(!quick.length){ render(handles,res?res.reply:""); renderShip(); openPopup(); }
          busy=false;
        });
      });
    }).catch(function(){busy=false;proceed();});
  }

  function onClick(e){
    if(busy)return;
    if(e.target.closest&&e.target.closest("#ep-up"))return;
    var el=e.target.closest?e.target.closest('button, a, input[type="submit"]'):null;
    if(!isCheckoutEl(el))return;
    if(!root&&!grab())return;

    e.preventDefault();
    e.stopPropagation();
    if(e.stopImmediatePropagation)e.stopImmediatePropagation();

    busy=true;
    pending=el;
    runPopup();
  }

  document.addEventListener("click",onClick,true);

  document.addEventListener("submit",function(e){
    if(busy)return;
    var f=e.target;
    if(!f||f.tagName!=="FORM")return;
    if(f.closest&&f.closest("#ep-up"))return;
    var act=(f.getAttribute("action")||"");
    if(!/\/cart/.test(act))return;
    var sb=f.querySelector('[name="checkout"]');
    if(!sb)return;
    if(!root&&!grab())return;
    e.preventDefault();
    e.stopPropagation();
    if(e.stopImmediatePropagation)e.stopImmediatePropagation();
    busy=true;
    pending=sb;
    runPopup();
  },true);

  function init(){
    if(!grab())return;

    /* EP PERF: Nur vorladen, wenn der Warenkorb beim Seitenaufruf Inhalt hat - und erst im Leerlauf des Browsers */
    if(INITIAL_COUNT>0){
      whenIdle(function(){ ensureLoaded().then(function(){ prefetch(); }); });
    }

    ["cart:refresh","cart:updated","cart:change"].forEach(function(ev){
      document.addEventListener(ev,function(){ CACHE.handles=null; setTimeout(function(){ ensureLoaded().then(function(){ prefetch(); }); },300); });
    });

    goBtn.addEventListener("click",function(e){ e.preventDefault(); e.stopPropagation(); proceed(); });
    root.querySelectorAll("[data-close]").forEach(function(el){
      el.addEventListener("click",function(){ closePopup(); pending=null; });
    });
    document.addEventListener("keydown",function(e){ if(e.key==="Escape"&&root&&!root.hidden){closePopup();pending=null;} });
  }

  if(document.readyState!=="loading"){init();}
  else{document.addEventListener("DOMContentLoaded",init);}
})();
